import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/page/index/index';
import LayoutOfDianying from '@/page/dianying/index';
import LayoutOfDianshiju from '@/page/dianshiju/index';
// import LayoutOfPlay from '@/views/layout/layout';
import LayoutOfVideo from '@/views/layout/layout';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      component: Layout,
      children: [{
        path: '',
        name: '主页',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/home/index')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/dianying',
      component: LayoutOfDianying,
      children: [{
        path: '',
        name: '电影',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/movie/dianying')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/dianshiju',
      component: LayoutOfDianshiju,
      children: [{
        path: '',
        name: '电视剧',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/movie/index')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/',
      name: '主页',
      redirect: '/index',
      meta:{
        login:false
      }
    },
    {
      path: '/video-play',
      component: LayoutOfVideo,
      children: [{
        path: '',
        name: '视频播放',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/video_play/index')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/film-play',
      component: LayoutOfVideo,
      children: [{
        path: '',
        name: '视频播放',
        id: '',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/film_play/index')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/search',
      component: LayoutOfDianying,
      children: [{
        path: '',
        name: '视频搜索',
        id: '',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/search/index')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/register',
      component: LayoutOfVideo,
      children: [{
        path: '',
        name: '用户注册',
        id: '',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/user/register')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/login',
      component: LayoutOfVideo,
      children: [{
        path: '',
        name: '用户登录',
        id: '',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/user/login')
      }]
    },
    {
      path: '/list',
      component: LayoutOfVideo,
      children: [{
        path: '',
        name: '资讯列表',
        id: '',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/article/list')
      }],
      meta:{
        login:false
      }
    },
    {
      path: '/detail',
      component: LayoutOfVideo,
      children: [{
        path: '',
        name: '资讯详情',
        id: '',
        component: () =>
          import( /* webpackChunkName: "views" */ '@/views/article/detail')
      }],
      meta:{
        login:false
      }
    },
  ]
});
//路由守卫
// router.beforeEach( async (to,from,next) => {
//   /*
//       有些路由是需要登录的，判断登录状态
//           1.没有登录：跳转到登录页
//           2.登录：直接进入
//       有些路由是不需要登录的，直接进入
//       ps：是否需要登录 --meta
//   */
//   const token = localStorage.getItem('token');
//   const isLogin = !!token;
//   //进入路由的时候，需要向后端发送token，验证是否合法
//   const data = await userInfo();
//   Store.commit('chageUserInfo',data.data)

//  if(to.matched.some(item => item.meta.login)){//需要登录
//       console.log("需要登录");

//       if(isLogin){//已经登录的，直接通过
//           if(data.error === 400){//后端告诉你，登录不成功
//               next({name:'login'});
//               localStorage.removeItem('token');
//               return;
//           }
//           if(to.name === 'login'){
//               next({name:'home'});
//           }else{
//               next();
//           }
//           return;
//       }
//       if(!isLogin && to.name === 'login'){//未登录，但是要去登录页
//           next();
//       }
//       if(!isLogin && to.name !== 'login'){//未登录，去的也不是登录页
//           next({name:'login'});
//       }
//  }else{
//      next();
//  }
// })
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js